interface IconProps {
  color?: string;
  className?: string;
}

export default function BatteryIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.68997 8.10006L5.30997 5.53006C5.55997 5.33006 5.91997 5.53006 5.81997 5.86006L4.53997 7.93006H6.08997C6.08997 7.93006 6.21997 7.99006 6.23997 8.00006C6.33997 8.07006 6.39997 8.26006 6.32997 8.37006L4.72997 10.9401C4.50997 11.1901 4.11997 10.9901 4.18997 10.6701L5.47997 8.57006H3.88997C3.88997 8.57006 3.79997 8.52006 3.78997 8.51006C3.66997 8.42006 3.62997 8.25006 3.69997 8.12006L3.68997 8.10006Z"
        fill={color}
      />
      <path
        d="M8.73 15.01H1.28C0.58 15.01 0 14.44 0 13.73V3.25C0 2.55 0.57 1.97 1.28 1.97H2.02V1.28C2.02 0.58 2.59 0 3.3 0H6.72C7.42 0 8 0.57 8 1.28V1.97H8.74C9.44 1.97 10.02 2.54 10.02 3.25V13.73C10.02 14.43 9.45 15.01 8.74 15.01H8.73ZM1.39 13.62H8.61V3.37H6.59V1.41H3.4V3.37H1.39V13.62Z"
        fill={color}
      />
    </svg>
  );
}
